export enum LocalStorageKeys {
    pdaBoracayInvited = 'pdaBoracayInvited',
    pdaBoracayGuestName = 'pdaBoracayGuestName',
}  